import {
  ElButton,
  ElCascader,
  ElCollapseTransition,
  ElConfigProvider,
  ElDatePicker,
  ElDialog,
  ElForm,
  ElFormItem,
  ElCheckbox,
  ElInfiniteScroll,
  ElInput,
  ElInputNumber,
  ElLoading,
  ElMessageBox,
  ElOption,
  ElPopover,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElSelect,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTabs,
  ElTooltip,
  ID_INJECTION_KEY,
  ZINDEX_INJECTION_KEY,
} from 'element-plus';

export default defineNuxtPlugin((nuxtApp) => {
  // Config
  ElDialog.props.destroyOnClose = {
    type: Boolean,
    default: true,
  };
  ElPopover.props.hideAfter.default = 0;
  ElPopover.props.persistent.default = false;
  ElTooltip.props.offset.default = 6;

  // Inject
  nuxtApp.vueApp.provide(ID_INJECTION_KEY, {
    prefix: 1024,
    current: 0,
  });
  nuxtApp.vueApp.provide(ZINDEX_INJECTION_KEY, {
    current: 0,
  });
  nuxtApp.vueApp.use(ElButton);
  nuxtApp.vueApp.use(ElCascader);
  nuxtApp.vueApp.use(ElCollapseTransition);
  nuxtApp.vueApp.use(ElConfigProvider);
  nuxtApp.vueApp.use(ElDatePicker);
  nuxtApp.vueApp.use(ElDialog);
  nuxtApp.vueApp.use(ElForm);
  nuxtApp.vueApp.use(ElFormItem);
  nuxtApp.vueApp.use(ElCheckbox);
  nuxtApp.vueApp.use(ElInfiniteScroll);
  nuxtApp.vueApp.use(ElInput);
  nuxtApp.vueApp.use(ElInputNumber);
  nuxtApp.vueApp.use(ElLoading);
  nuxtApp.vueApp.use(ElMessageBox);
  nuxtApp.vueApp.use(ElOption);
  nuxtApp.vueApp.use(ElPopover);
  nuxtApp.vueApp.use(ElRadio);
  nuxtApp.vueApp.use(ElRadioButton);
  nuxtApp.vueApp.use(ElRadioGroup);
  nuxtApp.vueApp.use(ElSelect);
  nuxtApp.vueApp.use(ElSwitch);
  nuxtApp.vueApp.use(ElTable);
  nuxtApp.vueApp.use(ElTableColumn);
  nuxtApp.vueApp.use(ElTabs);
  nuxtApp.vueApp.use(ElTooltip);
});
